export default {
  colors: {
    0: 'concrete',
    1: 'turquoise',
    2: 'peterRiver',
    3: 'wisteria',
  },
};
